import Cookies from 'js-cookie';
import { SegmentService } from '../analytics/segment-generated';
export const LOGGED_IN_COOKIE = 'token';
export const REMEMBER_ME_COOKIE = 'remember_me';
export const COOKIE_SETTINGS = { path: '/', domain: process.env.COOKIE_DOMAIN };

export const logOut = (segment: SegmentService): void => {
    segment.reset();
    Cookies.remove(LOGGED_IN_COOKIE, COOKIE_SETTINGS);
    Cookies.remove(REMEMBER_ME_COOKIE, COOKIE_SETTINGS);
};

export const isLoggedIn = (segment: SegmentService): Promise<boolean> => {
    const cookie = Cookies.get(LOGGED_IN_COOKIE);
    if (!cookie) {
        return Promise.resolve(false);
    }

    const accessToken = JSON.parse(cookie as string).access_token;
    if (!accessToken) {
        logOut(segment);
        return Promise.resolve(false);
    }

    const authorizationHeader = `Bearer ${accessToken}`;

    return fetch(`${process.env.GATSBY_MONOLITH_ENDPOINT}/api/v1/me/profile`, {
        headers: {
            Authorization: authorizationHeader,
        },
    })
        .then(response => response.json())
        .then(({ email }) => {
            if (!email) {
                logOut(segment);
            }

            return !!email;
        })
        .catch(() => {
            logOut(segment);
            return false;
        });
};
